import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"
import { GENERAL_CONFIG } from "one-verify/src/config/general.config.ts"

import type {
    INetworkStatusRulesListResult,
    INetworkStatusRulesVersion,
} from "@common-shared/types/responseData/commonResponseData.types.ts"

import { BrowserStorageType } from "@front-shared/config/general.config.ts"
import { BrowserStorageHelper } from "@front-shared/helpers/browserStorage.helper.ts"

import { UtilHelper } from "../../helpers/util.helper"
import type { INetworkStatusRulesFilters } from "../../types/networkStatus.types"
import type { INetworkStatusState } from "../../types/state.types.ts"

const initialState: INetworkStatusState = {
    items: [],
    pagination: UtilHelper.getPagination(),
    filters: {},
    versions: [],
    exportProgress: 0,
}

const networkStatusSlice = createSlice({
    name: "networkStatus",
    initialState,
    reducers: {
        networkStatusReset: () => initialState,

        networkStatusSetList: (
            state,
            action: PayloadAction<INetworkStatusRulesListResult>,
        ) => {
            state.items = action.payload.items
            state.pagination = action.payload.pagination
        },

        networkStatusSetFilters: (
            state,
            action: PayloadAction<INetworkStatusRulesFilters>,
        ) => {
            state.filters = action.payload

            BrowserStorageHelper.set(
                GENERAL_CONFIG.browserStorageKeys.networkStatusRulesFilters,
                action.payload,
                BrowserStorageType.sessionStorage,
            )
        },

        networkStatusSetVersions: (
            state,
            action: PayloadAction<INetworkStatusRulesVersion[]>,
        ) => {
            state.versions = action.payload
        },

        networkStatusSetExportProgress: (
            state,
            action: PayloadAction<number>,
        ) => {
            state.exportProgress = action.payload
        },
    },
})

export const {
    networkStatusReset,
    networkStatusSetList,
    networkStatusSetFilters,
    networkStatusSetVersions,
    networkStatusSetExportProgress,
} = networkStatusSlice.actions

export const networkStatusReducer = networkStatusSlice.reducer
